import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import { CookiesProvider } from 'react-cookie';

// Components
import Root from './components/Layout/Root';
import CookieBanner from './components/CookieBanner';
import ScrollTo from './components/Layout/OnRouteScrollTo';
import SystemMessage from './components/SystemMessage';

// Pages
import NotFound from './pages/404';
import Home from './pages/Home';
import About from './pages/About';
import Privacy from './pages/Privacy';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Cookies from './pages/Cookies';
import OldBrowser from './pages/OldBrowser';
import MakingOfAnIndustryLeader from './pages/CaseStudies/MakingOfAnIndustryLeader';
import BridgingTheGap from './pages/CaseStudies/BridgingTheGap';
import AdvocatingForPatientsHope from './pages/CaseStudies/AdvocatingForPatientsHope';

const Routes = () => (
  <ScrollTo>
    <Root>
      <SystemMessage />
      <CookiesProvider>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/about-us" component={About} />
          <Route exact path="/privacy" component={Privacy} />
          <Route exact path="/cookies" component={Cookies} />
          <Route exact path="/services" component={Services} />
          <Route exact path="/contact" component={Contact} />
          <Route exact path="/unsupported" component={OldBrowser} />
          <Route exact path="/making-of-an-industry-leader" component={MakingOfAnIndustryLeader} />
          <Route exact path="/bridging-the-gap" component={BridgingTheGap} />
          <Route exact path="/advocating-for-patients-hope" component={AdvocatingForPatientsHope} />
          <Route exact path="/404" component={NotFound} />
          <Route path="*" component={NotFound} />
        </Switch>
      </CookiesProvider>
      <CookieBanner />
    </Root>
  </ScrollTo>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/routes.jsx